const phonePattern = /^(\+375) (\d{2}) (\d{3}) (\d{2}) (\d{2})$/;
export default phonePattern;
